import { render, staticRenderFns } from "./socialChannel.vue?vue&type=template&id=7a8f1266&"
import script from "./socialChannel.vue?vue&type=script&lang=js&"
export * from "./socialChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a8f1266')) {
      api.createRecord('7a8f1266', component.options)
    } else {
      api.reload('7a8f1266', component.options)
    }
    module.hot.accept("./socialChannel.vue?vue&type=template&id=7a8f1266&", function () {
      api.rerender('7a8f1266', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/socialChannel.vue"
export default component.exports